import { SHOP_ACTION, SHOP_ACTION_LOADER } from "../type"
 
const initialState ={
    loader : false,
    data :{}
}
 
const listingReducer  = (state = initialState, action) => {
    switch (action.type){
        case SHOP_ACTION_LOADER:{
            return {...state,loader : action.loader};
        }
        case SHOP_ACTION :{
            return {...state, data: action.data};
        }
        default :{
            return state
        }
    }
}
 
export default listingReducer;